import { inject, Injectable } from '@angular/core';
import { SIGNAL_R_PROPERTIES } from '../properties/signal-r.properties';

import { SignalREventModel, SignalRService } from '@gan/core/util-signalr';
import { AuthService } from '@gan/common/feature-auth';
import { OpsNotificationModel } from '../models';

@Injectable({ providedIn: 'root' })
export class OpsNotificationsSignalRServiceService extends SignalRService<SignalREventModel<OpsNotificationModel>[]> {
  private authService = inject(AuthService);

  hubMethod = SIGNAL_R_PROPERTIES.method;

  /**
   * start signalR ops notifications hub connection
   */
  override startHubConnection(hubName = SIGNAL_R_PROPERTIES.notificationsHub) {
    return super.startHubConnection(hubName, this.authService.signalRConnectionOptions);
  }
}
